import ModalIcon from 'components/common/Modal/ModalIcon';
import { ReactNode } from 'react';
import { Button, Modal as BootstrapModal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ModalProps {
  children?: any;
  title: string;
  submitBtnText: string;
  cancelBtnText?: string;
  show: boolean;
  disabled?: boolean;
  withIcon: boolean;
  submitDisabled?: boolean;
  hideCancelBtn?: boolean;
  displayCloseButton?: boolean;
  type: 'success' | 'danger';
  modalClassName?: string;
  modalBodyClassName?: string;
  withIconBodyText?: ReactNode;
  footerContentAlignment?: 'left' | 'right' | 'center';
  onSubmit: any;
  onClose: () => void;
  onCancel?: () => void;
  onBackDropClick?: () => void;
}

const Modal = ({
  children,
  title,
  submitBtnText,
  cancelBtnText,
  show,
  disabled,
  submitDisabled,
  withIcon,
  hideCancelBtn,
  type,
  displayCloseButton = true,
  modalClassName,
  modalBodyClassName,
  withIconBodyText,
  footerContentAlignment,
  onSubmit,
  onClose,
  onCancel,
  onBackDropClick,
}: ModalProps) => {
  const { t } = useTranslation();
  return (
    <BootstrapModal
      show={show}
      className={modalClassName}
      centered
      onHide={onBackDropClick}
    >
      <BootstrapModal.Header
        closeButton={displayCloseButton}
        onHide={onClose}
        closeVariant={'white'}
        className={'bg-primary'}
        style={{ minHeight: withIcon ? 75 : 'auto' }}
      >
        {!withIcon && <BootstrapModal.Title>{title}</BootstrapModal.Title>}
      </BootstrapModal.Header>
      {withIcon && <ModalIcon type={type} />}
      <BootstrapModal.Body className={modalBodyClassName}>
        {!withIcon ? (
          children
        ) : (
          <>
            <h3 className="mb-0 text-center">
              {withIconBodyText || t('modal_body_are_you_sure')}
            </h3>
            <div className="text-center d-flex flex-column align-items-center">
              {children}
            </div>
          </>
        )}
      </BootstrapModal.Body>

      <BootstrapModal.Footer
        className={`border-0 justify-content-${
          footerContentAlignment || 'between'
        }`}
      >
        {withIcon && (
          <>
            {!hideCancelBtn && (
              <Button
                variant="outline-primary"
                onClick={onClose}
                className="min-w-100"
                disabled={disabled}
              >
                {cancelBtnText}
              </Button>
            )}
          </>
        )}
        {onCancel && (
          <Button
            variant="outline-primary"
            onClick={onCancel}
            className="min-w-100"
            disabled={disabled}
          >
            {cancelBtnText || t('btn_cancel')}
          </Button>
        )}
        {submitBtnText && (
          <Button
            variant="primary"
            onClick={onSubmit}
            className="min-w-100"
            disabled={disabled || submitDisabled}
          >
            {submitBtnText}
          </Button>
        )}
      </BootstrapModal.Footer>
    </BootstrapModal>
  );
};

export default Modal;

Modal.defaultProps = {
  withIcon: false,
  type: 'danger',
  hideCancelBtn: false,
};
